import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Caption1 as Text } from '@fluentui/react-components';

import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import { Asset } from '../utils/types';
import { useAssetPreviewStyles } from '../styles/asset-preview-styles';
import { getLocalizedCallToActionString } from '../utils/get-localized-call-to-action-string';

export function AssetPreview({
  i18n,
  asset,
  withAspectRatio,
}: { i18n: any, asset: Asset, withAspectRatio: boolean }) {
  const styles = useAssetPreviewStyles();
  const preview = useMemo(() => {
    const assetType = asset.Asset.AssetType;
    if (assetType === 'Image') {
      return (
        <div className={styles.imagePreviewContainer}>
          <CroppedImageView
            resizeImageHeight={48}
            src={asset.Asset.ImageUrl}
            originalWidth={asset.Asset.CropWidth}
            originalHeight={asset.Asset.CropHeight}
            aspectRatio={asset.Asset.CropWidth / asset.Asset.CropHeight}
          />
          {withAspectRatio &&
            <Text className={classNames('aspect-ratio', styles.aspectRatio)}>{`${asset.Asset.CropWidth} x ${asset.Asset.CropHeight}`}</Text>
          }
        </div>
      );
    } else if (assetType === 'CallToAction') {
      return (
        <Text className={classNames('call-to-action', styles.text)}>
          {getLocalizedCallToActionString(asset.Asset.CallToAction, i18n)}
        </Text>
      );
    } else if (assetType === 'Video') {
      return (
        <div className={styles.imagePreviewContainer}>
          <CroppedImageView
            resizeImageHeight={48}
            src={asset.Asset.ThumbnailUrl}
            originalWidth={asset.Asset.Width}
            originalHeight={asset.Asset.Height}
            aspectRatio={asset.Asset.Width / asset.Asset.Height}
          />
          {withAspectRatio &&
            <Text className={classNames('aspect-ratio', styles.aspectRatio)}>{`${asset.Asset.Width} x ${asset.Asset.Height}`}</Text>
          }
        </div>
      );
    }
    return (<Text className={classNames('text-preview', styles.text)}>{asset.Asset.Text || i18n.getString(_TL_('-'))}</Text>);
  }, [asset, i18n, styles, withAspectRatio]);
  return (
    <div className={classNames('asset-preview', styles.container)}>
      {preview}
    </div>
  );
}
